import { useCallback, useState } from "react";
import { Button } from "components/UI/atoms";
import { BrandAlertModal, DiscountPopover } from "components/UI/molecules";
import { useAppContext } from "context/app-context";
import { INTERNAL_PATHS } from "routes/paths";
import { useNavigate } from "hooks/useCustomNavigation";
import { setReturnToCookie } from "services/cookies";
import "./index.scss";

export const DiscountHeader = ({ brandDetails, brandSEO }) => {
  const {
    savings,
    name,
    instantConfig: { increment, denominations },
    quantity_available,
    productSourceId
  } = brandDetails;
  const { h2Discount } = brandSEO;
  const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
  const {
    sessionInfo: { isLoggedIn }
  } = useAppContext();
  const navigate = useNavigate();

  const hasCashback = increment || denominations.length;
  const isOutOfStock = quantity_available < 1;
  const isSavingsValid = !isNaN(Number(savings));

  const handleTrackButtonClick = useCallback(() => {
    if (!isLoggedIn) {
      setReturnToCookie(window.location.href);
      navigate(INTERNAL_PATHS.USER_LOG_IN);
    }

    setAlertModalIsOpen(true);
  }, [navigate, isLoggedIn]);

  return (
    <>
      <div className={`discount-header ${hasCashback && "has-cashback"}`}>
        {!isOutOfStock && (
          <div className="discount-section">
            UP TO {parseFloat(savings).toFixed(2)}% OFF
          </div>
        )}
        <div className="header-content">
          <h2 className="title">
            {h2Discount ? (
              <span dangerouslySetInnerHTML={{ __html: h2Discount }} />
            ) : (
              "Discount Gift Cards"
            )}
          </h2>
          <DiscountPopover />
        </div>
        {isOutOfStock ? (
          <div className="cashback-container">
            <hr />
            <p className="sold-out-text">
              <strong>Sorry, we’re all sold out!</strong> As GCX is a
              marketplace, gift cards can sell out at any time. Track prices and
              get notified when {name} is back in stock or browse top coupons
              now.
            </p>
            <div className="buttons-container">
              <Button
                customClassName="alert-button"
                onClick={handleTrackButtonClick}
              >
                SET BRAND ALERT
              </Button>
            </div>
          </div>
        ) : (
          name &&
          isSavingsValid && (
            <p className="discount-text">
              Save up to {Number(savings)}% when you buy discounted{" "}
              <span className="bold-brand-name">{name}</span> gift cards from
              our marketplace.
            </p>
          )
        )}
      </div>
      {alertModalIsOpen && (
        <BrandAlertModal
          handleClose={() => setAlertModalIsOpen(false)}
          isOpen={alertModalIsOpen}
          productSourceId={productSourceId}
          name={name}
        />
      )}
    </>
  );
};
